module.exports = __webpack_public_path__ + "static/media/sockets.4d47fb5f.jpg";